import { Tooltip } from '@mui/material';
import { BsMagic } from 'react-icons/bs';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const GenerationButton = ({
    formikProps,
    platform,
    text,
    handleGenerate,
    isLoading,
    additionalSx={}
}) => {
    const { t } = useTranslation();
    const { userInfo } = useSelector((state) => state?.auth);
    const isGenerateDisabled = !formikProps.values.seo_request 
    || !formikProps.values.subject
    || !userInfo[`${platform}_api_key`]
    || userInfo[`${platform}_requires_funding`]
    || (userInfo?.payment_status !== "active" && userInfo?.payment_status !== "trial");

    const platforms = {"openai": "OpenAI", "perplexity": "Perplexity"}

    const getTooltipMessage = () => {
      const { seo_request, subject } = formikProps.values;
      if (!seo_request && !subject) return t("you-must-fill-seo-request-and-subject", 'You must fill SEO target request and subject');
      if (!seo_request) return t("you-must-fill-seo-request", 'You must fill SEO target request');
      if (!subject) return t("you-must-fill-subject", 'You must fill subject');
      if (!userInfo[`${platform}_api_key`]) return t(`you-must-have-an-active-${platform}-api-key`, `Vous devez avoir une clé API ${platforms[platform]} active`);
      if (userInfo[`${platform}_requires_funding`]) return t(`you-must-add-funds-to-your-${platform}-account`, `Vous devez ajouter des fonds à votre compte ${platforms[platform]}`);
      if (userInfo?.payment_status !== "active" && userInfo?.payment_status !== "trial") return t(`you-must-have-an-active-account`, `Vous devez avoir un compte actif`);
      return '';
    };

    return (
        <Tooltip
            title={isGenerateDisabled ? getTooltipMessage() : ''}
            slotProps={{
                popper: {
                    sx: { zIndex: 99999999 }
                }
            }}
        >
            <span>
                <LoadingButton
                    startIcon={<BsMagic />}
                    loading={isLoading}
                    onClick={handleGenerate}
                    variant="contained"
                    disabled={isGenerateDisabled}
                    sx={{
                        textTransform: 'none',
                        bgcolor: '#8b5cf6',
                        '&:hover': {
                            bgcolor: '#7c3aed'
                        },
                        ...additionalSx
                    }}
                >
                    {text}
                </LoadingButton>
            </span>
        </Tooltip>
    )
};
